
import { Vue, Component, Prop } from "vue-property-decorator";
import First from "./First.vue";
import Access from "./Access.vue";
import ThankYou from "./ThankYou.vue";
import { api } from "../api";
import { DEMO_FORM_STEPS } from "../service";
import { makeAnalytics } from "../analytics";
import { getToken } from "@/session/auth";
@Component({
  components: {
    First,
    Access,
    ThankYou
  }
})
export default class extends Vue {
  @Prop(String) readonly json!: string;
  configFirst = JSON.parse(this.json);
  configThankYou = this.configFirst.thankYou;
  configAccess = this.configFirst.access;

  formData: any = {
    formClass: `sign-up ${this.configFirst.formClass}`
  };
  analytics = makeAnalytics();
  STEPS = DEMO_FORM_STEPS;
  currentStep = DEMO_FORM_STEPS.FIRST_STEP;

  mounted() {
    if (this.sessionToken) {
      this.currentStep = this.STEPS.ACCESS_STEP;
    }

    api.setLocale(this.configFirst.locale);
  }

  onFirstStep() {
    this.currentStep = this.STEPS.FIRST_STEP;
  }

  get sessionToken() {
    return getToken();
  }

  async onSuccess(formData: any) {
    this.formData = { ...this.formData, ...formData };
    this.analytics.gtm.eventCall("UserID", {
      UserID: formData.data.id
    });
    this.analytics.gtm.eventCall(this.configFirst.registration_event, {});
    this.currentStep = this.STEPS.THANK_YOU_STEP;
  }

  onAccessSuccess() {
    this.analytics.gtm.eventCall(this.configFirst.registration_event, {});
    this.currentStep = this.STEPS.THANK_YOU_STEP;
  }
}
